import React, { useEffect, useState } from "react";
import RouletteCat from "../../assets/images/categories/Roulette.png";
import AndarBaharCat from "../../assets/images/categories/AndarBahar.png";
import BaccaratCat from "../../assets/images/categories/Baccarat.png";
import BlackjackCat from "../../assets/images/categories/Blackjack.png";
import DragonTigerCat from "../../assets/images/categories/DragonTiger.png";
import PokerCat from "../../assets/images/categories/Poker.png";
import SpribeCat from "../../assets/images/categories/Spribe.png";
import SupernowaCat from "../../assets/images/categories/Supernowa.png";
import VivoCat from "../../assets/images/categories/Vivo.png";
import TVShowsCat from "../../assets/images/categories/TVShow.png";
import AllgamesCat from "../../assets/images/categories/AllGame.png";
import SicboCat from "../../assets/images/categories/Sicbo.png";
import Cards32Cat from "../../assets/images/categories/Cards32.png";
import Lucky7Cat from "../../assets/images/categories/Lucky7.png";
import { Dropdown } from "react-bootstrap";
import SpeedRoulette from "../../assets/images/roulette/home/speed-roulette1.jpg";
import play from "../../assets/images/play-btn.png";
import { casinoSection as casinoData } from "../../lib/data/casinoSection.data";
import { auraGames } from "../../lib/data/auraGames.data";
import { getNotifications } from "../../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector } from "react-redux";

const CasinoGamesSection = () => {
  const casinoSection = { ...casinoData, ...auraGames };
  const { isAuth } = useSelector((state) => state.auth);
  const [selectedProvider, setSelectedProvider] = useState({
    id: 1,
    name: "All",
    eventKey: "all",
  });
  const [activeTab, setActiveTab] = useState({
    id: 1,
    name: "All Games",
    key: "popularGames",
    imgSrc: AllgamesCat,
  });
  const [customActiveTab, setCustomActiveTab] = useState(null);
  const [allGamesData, setAllGamesData] = useState(null);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);

  const providersArray = [
    { id: 1, name: "All", eventKey: "all" },
    { id: 2, name: "Evolution", eventKey: "evolution" },
    { id: 3, name: "Ezugi", eventKey: "ezugi" },
    { id: 4, name: "Vivo", eventKey: "vivo" },
    { id: 5, name: "Aura", eventKey: "aura" },
  ];
  const tabsArray = [
    {
      id: 1,
      name: "Popular Games",
      key: "popularGames",
      imgSrc: AllgamesCat,
    },

    {
      id: 3,
      name: "Roulette",
      key: "roulettetab",
      imgSrc: RouletteCat,
    },
    {
      id: 4,
      name: "Dragon Tiger",
      key: "dragontiger",
      imgSrc: RouletteCat,
    },
    {
      id: 5,
      name: "Baccarat",
      key: "baccarattab",
      imgSrc: BaccaratCat,
    },
    // {
    //   id: 6,
    //   name: "Tv Shows",
    //   key: "tvShows",
    //   imgSrc: TVShowsCat,
    // },
    {
      id: 7,
      name: "Blackjack",
      key: "blackjacktab",
      imgSrc: BlackjackCat,
    },
    {
      id: 2,
      name: "Andar Bahar",
      key: "AndarBahar",
      imgSrc: TVShowsCat,
    },
    {
      id: 8,
      name: "Poker",
      key: "pokertab",
      imgSrc: PokerCat,
    },
  ];

  useEffect(() => {
    filterAllGamesData();

    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const manageActiveTab = (provider) => {
    // let filteredTabs = [];
    // for (let key in casinoSection) {
    //   Object.values(casinoSection[key]).map((values) => {
    //     if (
    //       typeof values !== "string" &&
    //       values?.providerName?.toLowerCase() === provider.eventKey
    //     ) {
    //       if (!filteredTabs.some((e) => e === key)) {
    //         filteredTabs.push(key);
    //       }
    //     }
    //   });
    // }
    // let tabToBeActive = "";
    // for (let i = 0; i < filteredTabs?.length; i++) {
    //   const filterValue = tabsArray.find((f) => f.key === filteredTabs[i]);
    //   if (filterValue) {
    //     tabToBeActive = filterValue;
    //     break;
    //   }
    // }
    // setCustomActiveTab(tabToBeActive);
    // setCustomActiveTab({
    //   id: 1,
    //   name: "All Games",
    //   key: "allGames",
    //   imgSrc: RouletteCat,
    // });
    // filterAllGamesData(provider.eventKey);
  };

  const getTabActiveClass = (tab) => {
    if (customActiveTab) {
      return tab.key === customActiveTab.key;
    }
    return tab.key === activeTab?.key;
  };
  const filterAllGamesData = (provider = selectedProvider?.eventKey) => {
    let emptyArray = {};
    Object.keys(casinoSection).map((key) => {
      // console.log("key", key);
      if (
        key !== "allGames" &&
        tabsArray.some((s) => s.key === key) &&
        typeof casinoSection[key] !== "string"
      ) {
        emptyArray = { ...emptyArray, ...casinoSection[key] };
      }
    });
    let filteredValues;
    if (provider !== "all") {
      filteredValues = Object.values(emptyArray).filter(
        (f) => f.providerName?.toLowerCase() === provider
      );
    } else {
      filteredValues = Object.values(emptyArray).filter(
        (f) =>
          f.providerName?.toLowerCase() === "evolution" ||
          f.providerName?.toLowerCase() === "ezugi" ||
          f.providerName?.toLowerCase() === "vivo" ||
          f.providerName?.toLowerCase() === "aura"
      );
    }

    setAllGamesData(filteredValues);
  };
  return (
    <div className="casino-games">
      <div className="game-filter">
        <ul className="categories">
          {tabsArray?.map((tab, index) => {
            return (
              <React.Fragment key={index}>
                {((casinoSection?.[tab?.key] &&
                  Object.values(casinoSection?.[tab?.key]).some(
                    (s) =>
                      s?.providerName?.toLowerCase() ===
                      selectedProvider?.eventKey
                  )) ||
                  selectedProvider?.eventKey === "all" ||
                  tab?.key == "GamesAll") && (
                  <li
                    onClick={() => {
                      setCustomActiveTab(null);
                      if (tab.key === "allGames") {
                        filterAllGamesData();
                      }
                      setActiveTab(tab);
                    }}
                    // key={index}
                  >
                    <a
                      // href="javascript:void(0)"
                      className={getTabActiveClass(tab) ? "active" : ""}
                    >
                      <img src={tab?.imgSrc} alt="roulette" />
                      <span>{tab?.name}</span>
                    </a>
                  </li>
                )}
              </React.Fragment>
            );
          })}
        </ul>

        <div className="providers d-none">
          <Dropdown
            onSelect={(e) => {
              const provider =
                providersArray.find((p) => p?.eventKey === e) || "all";
              setSelectedProvider(provider);
              // manageActiveTab(provider);
            }}
          >
            <Dropdown.Toggle
              variant="success"
              id="provider-dropdown"
              value={selectedProvider}
            >
              {selectedProvider?.name}
            </Dropdown.Toggle>

            <Dropdown.Menu value={selectedProvider}>
              {providersArray.map((p, index) => {
                return (
                  <Dropdown.Item key={index} eventKey={p?.eventKey}>
                    {p?.name}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="all-images">
        <ul>
          {casinoSection?.[activeTab?.key] &&
          activeTab?.key !== "allGames" &&
          customActiveTab?.key !== "allGames"
            ? Object.values(casinoSection?.[activeTab?.key]).map(
                (casino, index) => {
                  return (
                    <React.Fragment key={index}>
                      {(selectedProvider?.eventKey === "all" ||
                        casino?.providerName?.toLowerCase() ===
                          selectedProvider.eventKey) && (
                        <li key={index}>
                          <a href={casino?.redirectUrl}>
                            <img src={casino?.imgUrl} />
                            <img src={play} className="play_button" />
                            <p>{casino?.name}</p>
                            <p className="hover_Name">{casino?.name}</p>
                          </a>
                          <span className="focus-border">
                            <i></i>
                          </span>
                        </li>
                      )}
                    </React.Fragment>
                  );
                }
              )
            : allGamesData &&
              allGamesData.map((casino, index) => {
                return (
                  <li key={index}>
                    <a href={casino?.redirectUrl}>
                      <img src={casino?.imgUrl} />
                      <img src={play} className="play_button" />
                      <p>{casino?.name}</p>
                      <p className="hover_Name">{casino?.name}</p>
                    </a>
                    <span className="focus-border">
                      <i></i>
                    </span>
                  </li>
                );
              })}
        </ul>
      </div>
    </div>
  );
};
export default CasinoGamesSection;
